<template lang="pug">
  .operator-card
    .operator-card__title
      h1.title Профиль №{{userData.id}}
    .operator-card__content

      form.profile-page-form
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Общая информация
          .profile-section__body
            request-general-info(
            :lastName="userData.last_name"
            :firstName="userData.first_name"
            :fathersName="userData.fathers_name"
            :gender="userData.gender"
            :dateOfBirth="userData.date_of_birth"
            :placeOfBirth="userData.place_of_birth"
            :isAccompanying="userData.is_accompanying"
            :area="userData.area"
            :user-id="(userData.id).toString()"
            )
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title {{educationSectionTitle}}
          .profile-section__body
            request-education(
            :area="userData.area.name"
            :schoolAddress="userData.school_address"
            :schoolName="userData.school_name"
            :isAccompanying="userData.is_accompanying"
            )
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Контакты
          .profile-section__body
            request-contacts(
            :email="userData.email"
            :phone="userData.phone"
            :parents-phone="userData.parents_phone"
            )

        section.profile-page-form__section.profile-section(
        v-if="!userData.is_accompanying"
        )
          .profile-section__title
            h2.profile-section-title Портфолио ребенка за последний год
          .profile-section__body
            request-portfolio(
            :awards="awards"
            @onShowPortfolioModal="onShowPortfolioModal"
            )
        section.profile-page-form__section.profile-section(
        v-if="showButtons"
        )
          .profile-section__body
            .form
              .form__elem.form__elem_button-container.form__elem_full
                button.button.button_long(
                :class="{'loaded-button' : buttonPending}"
                v-if="showCancelButton"
                @click.prevent="onCancelButtonClick"
                )
                  .button__text Отклонить
                button.button.button_paint-main.button_long(
                :class="{'loaded-button' : buttonPending}"
                @click.prevent="setShowApproveModal(orderId, orderStatus)"
                )
                  .button__text {{ approveButtonText }}
        section.profile-page-form__section.profile-section
          .profile-section__body
            p {{ rejectReasonMessage }}

    modal(
    v-if="showModal"
    :mode="modalMode"
    :modalData="modalData"
    @close="showModal = false"
    @changeModalMode="changeModalMode"
    )

</template>

<script>
import { mapActions } from "vuex";
import RequestGeneralInfo from "./components/request-general-info.vue";
import RequestEducation from "./components/request-education.vue";
import RequestContacts from "./components/request-contacts.vue";
import RequestPortfolio from "./components/request-portfolio.vue";
import Modal from "../../components/modal/modal.vue";

export default {
  components: {
    Modal,
    RequestGeneralInfo,
    RequestEducation,
    RequestContacts,
    RequestPortfolio,
  },
  name: "RequestPage",
  props: ["id"],
  data() {
    return {
      orderId: null,
      userData: {
        id: "",
        last_name: "",
        first_name: "",
        fathers_name: "",
        gender: "",
        date_of_birth: "",
        place_of_birth: "",
        area: {
          id: null,
          name: null,
        },
        school_address: "",
        school_name: "",
        email: "",
        phone: "",
        passport: "",
        passport_issue_date: "",
        passport_attachments: [],
        birth_certificate: "",
        birth_certificate_attachments: [],
        snils: "",
        snils_attachments: [],
        inn: "",
        inn_attachments: [],
        is_accompanying: false,
      },
      user: {},
      awards: [],
      orderStatus: null,
      showModal: false,
      modalMode: "",
      modalData: null,
      buttonPending: false,
      rejectReason: null,
      rejectComment: "",
      rejectDocumentsComment: "",
      awardTypesData: null,
      awardPlaces: null,
    };
  },
  computed: {
    approveButtonText() {
      if (this.orderStatus === 1) {
        return "Взять в работу";
      } else if (this.orderStatus === 2) {
        return "Принять";
      } else {
        return "";
      }
    },
    showCancelButton() {
      if (this.orderStatus === 1) {
        return false;
      } else {
        return true;
      }
    },
    showButtons() {
      return false;
      // return this.orderStatus === 1 || this.orderStatus === 2;
    },
    rejectReasonMessage() {
      if (this.rejectReason === 1) {
        return (
          "Заявка была отклонена по причине: Недействительные документы. Подробнее: " +
          this.rejectDocumentsComment
        );
      } else if (this.rejectReason === 2) {
        return "Заявка была отклонена по причине: Не прошла по рейтингу";
      } else if (this.rejectReason === 3) {
        return "Заявка была отклонена по причине: " + this.rejectComment;
      } else {
        return "";
      }
    },
    educationSectionTitle() {
      if (this.userData.is_accompanying) {
        return "Место работы";
      } else {
        return "Учебное заведение";
      }
    },
  },
  methods: {
    ...mapActions([
      "getOrder",
      "getUser",
      "updateOrderStatus",
      "getAwardPlaces",
      "getAwardTypes",
    ]),
    onApproveButtonClick(id, status, isConfirmReserve) {
      this.buttonPending = true;
      let nextStatus = function () {
        if (status === 1) {
          return 2;
        } else if (status === 2 && !isConfirmReserve) {
          return 3;
        } else if (isConfirmReserve) {
          return 4;
        }
      };
      this.updateOrderStatus({ id: id, status: nextStatus() }).then((res) => {
        if (res.status === 200) {
          this.orderStatus = nextStatus();
          if (this.orderStatus === 2) {
            this.modalMode = "notification";
            this.modalData = {
              title: "Успешно",
              text: "Заявка взята в работу",
            };
          } else if (this.orderStatus === 3) {
            if (res.data.quota_filled === true) {
              this.modalMode = "notification";
              this.modalData = {
                text: "Мест нет.",
                buttonText: "Продолжить",
                redirectToRequests: true,
              };
            } else {
              this.modalMode = "notification";
              this.modalData = {
                title: "Успешно",
                text: "Заявка подтверждена",
                redirectToRequests: true,
              };
            }
          }
          this.showModal = true;
        } else if (res.status === 400) {
          console.log(res.status);
          /*if (res.data[0].code === 20) {
              this.modalMode = "confirm-reserve"
              this.modalData = {
                text: "В квоте больше нет мест. Данная заявка будет переведена в \"Резерв\"",
                id: id
              }
              this.showModal = true;
            }*/
        }
        this.buttonPending = false;
      });
    },
    onCancelButtonClick() {
      this.setShowRejectionModal();
    },
    onReserveButtonClick(id) {
      this.buttonPending = true;
      this.updateOrderStatus({ id: id, status: 4 }).then(() => {
        this.modalMode = "notification";
        this.modalData = {
          title: "Успешно",
          text: "Заявка переведена в резерв",
          redirectToRequests: true,
        };
        this.showModal = true;
        this.buttonPending = false;
      });
    },
    setShowApproveModal(id, status) {
      if (this.orderStatus == 2 && this.user.role == 6) {
        // Если заявка на принятие и пользователь Модератор
        this.showModal = true;
        this.modalMode = "operator-approve";
        this.modalData = {
          id: this.orderId,
        };
      } else {
        console.log(id, status);
        // this.onApproveButtonClick(id, status);
      }
    },
    setShowRejectionModal() {
      this.showModal = true;
      this.modalMode = "operator-rejection";
      this.modalData = {
        id: this.orderId,
      };
    },
    onGetOrders(id) {
      this.getOrder(id).then((res) => {
        this.awards = res.awards;
        this.orderId = res.id;
        this.userData = res.user;
        this.orderStatus = res.current_status.status;
        this.rejectReason = res.current_status.reject_reason;
        this.rejectComment = res.current_status.comment;
        this.rejectDocumentsComment = res.current_status.documents_comment;
      });
    },
    changeModalMode(mode) {
      this.modalMode = mode;
    },

    onShowPortfolioModal(index) {
      this.showModal = true;
      this.modalMode = "awards-read-only";
      this.modalData = {
        currentAward: this.awards[index],
        awardTypes: this.awardTypesData,
      };
    },
  },
  mounted() {
    this.onGetOrders(this.$props.id);
    this.getAwardTypes().then((res) => {
      this.awardTypesData = res;
    });
    this.getUser().then((res) => {
      this.user = res;
    });
  },
};
</script>
